import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, Subject, Subscription } from 'rxjs';
import { DirectorySearch } from 'src/app/generales/login/pages/perfil/interfaces-perfil/interfacesPerfil';
const url = environment.url;

@Injectable({
  providedIn: 'root',
})
export class DirectorioService {
  citiesSource: Subject<any> = new Subject();
  citiesObs = this.citiesSource.asObservable();

  constructor(private http: HttpClient) {}

  getData(query: DirectorySearch) {
    // text: any = '', pag: number, category = '', country = '1', city = '1', sector = '1'
    const data: any = query;
    return this.http.get<any>(`${url}/directory/search`, {
      params: data
    });
  }

  getStore(id: any){
    return this.http.get<any>(`${url}/directory/store/${id}`);
  }

  postContact(body){
    return this.http.post<any>(`${url}/contact`, body);

  }
}
